import { render, staticRenderFns } from "./ViewDiscountModal.vue?vue&type=template&id=617d9368&scoped=true&"
import script from "./ViewDiscountModal.vue?vue&type=script&lang=js&"
export * from "./ViewDiscountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617d9368",
  null
  
)

export default component.exports